<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="more"></ion-back-button>
    </ion-buttons>
    <ion-title>Permissions</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content>
  <div class="tw:m-4 tw:text-xs">
    <ion-note color="medium">
      For full functionality, this app requires permission to access some of your device's features.
    </ion-note>
  </div>
  <ion-list [inset]="true" lines="full" class="no-last-line">
    <ion-item>
      <ion-toggle
        [disabled]="isWebBrowser"
        [checked]="pushNotificationsPermission"
        (click)="openNativeSettings($event, androidSettings.AppNotification)"
        helperText="Required to receive Farm Alerts and other notifications."
      >
        Push Notifications
      </ion-toggle>
    </ion-item>
    <ion-item>
      <ion-toggle
        [disabled]="isWebBrowser"
        [checked]="locationPermission"
        (click)="openNativeSettings($event, androidSettings.Location)"
        helperText="Required for Camera View search and some map search features."
      >
        Location
      </ion-toggle>
    </ion-item>
    <ion-item>
      <ion-toggle
        [disabled]="isWebBrowser"
        [checked]="cameraPermission"
        (click)="openNativeSettings($event)"
        helperText="Required for Camera View search."
      >
        Camera
      </ion-toggle>
    </ion-item>
  </ion-list>
</red-page-content>
